export const isDeployPreview = () => {
  return (
    (process.env.NEXT_PUBLIC_IS_NETLIFY &&
      process.env.NEXT_PUBLIC_NETLIFY_CONTEXT === "deploy-preview") ||
    process.env.NEXT_PUBLIC_ENV_API == "https://api-staging.monthly.com" || // running on staging
    process.env.NEXT_PUBLIC_ENV_API == "https://monthly-backend.ngrok.io" // running on ngrok
  );
};
